import { render, staticRenderFns } from "./Reel.vue?vue&type=template&id=b013cc9c&scoped=true&"
import script from "./Reel.vue?vue&type=script&lang=js&"
export * from "./Reel.vue?vue&type=script&lang=js&"
import style0 from "./Reel.vue?vue&type=style&index=0&id=b013cc9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b013cc9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCarousel,VCarouselItem,VFlex,VImg})
